import admitone from 'assets/images/PromoIcons/admitone.png';
import bank from 'assets/images/PromoIcons/bank.png';
import calendar from 'assets/images/PromoIcons/calendar.png';
import count from 'assets/images/PromoIcons/count.png';
import dart from 'assets/images/PromoIcons/dart.png';
import diamond from 'assets/images/PromoIcons/diamond.png';
import dots from 'assets/images/PromoIcons/dots.png';
import graph from 'assets/images/PromoIcons/graph.png';
import list from 'assets/images/PromoIcons/list.png';
import moneybag from 'assets/images/PromoIcons/moneybag.png';
import pin from 'assets/images/PromoIcons/pin.png';
import satelite from 'assets/images/PromoIcons/satelite.png';
import warning from 'assets/images/PromoIcons/warning.png';
import { PromoIconProps } from 'features/PromoConditions';
import { memo } from 'react';

const promoIcons: Record<string, string> = {
	admitone,
	bank,
	calendar,
	count,
	dart,
	diamond,
	dots,
	graph,
	moneybag,
	pin,
	warning,
	satelite,
	list,
};

const PromoConditionsIconComponent = ({ name, alt = '', className }: PromoIconProps) => {
	const src = promoIcons[name];

	if (!src) return null;

	return (
		<div className="w-5 h-5 flex items-center justify-center">
			<img src={src} alt={alt || name} className="block w-3 h-3" />
		</div>
	);
};

export const PromoConditionsIcon = memo(PromoConditionsIconComponent);
